import React from 'react';

const EtiquetaConfirmador = (props) => {

    return (
        <i className="icon-confirmador222 clickable" aria-hidden="true" onClick={() => { props.openModalConfirmador(props.entidadTipo, props.id) }}></i>
    );
}

export default EtiquetaConfirmador;